<template>
<div id="container" class="main">
    <h2>check your email</h2>
    <br>
    <div id="envelope" class="letter">
        <svg width="290" height="105" xmlns="http://www.w3.org/2000/svg" version="1.1">
            <path d="M 0 5 L 150 100 L 300 5" fill="none" stroke="orange" stroke-width="3" />
            <path class="mail" d="M 0 30 C 40 10, 60 10, 150 30 S 300 30, 300 30"
        fill="none" stroke="tan" stroke-width="2"  />
  
            <path class="mail" d="M 0 45 C 40 25, 60 25, 150 45 S 300 45, 300 45"
        fill="none" stroke="grey" stroke-width="2"  />
  
            <path class="mail" d="M 0 60 C 40 40, 60 40, 150 60 S 300 60, 300 60"
        fill="none" stroke="black" stroke-width="2"  />
            <text x="145" y="90">@</text>
        </svg>

    </div>

</div>
</template>

<script>
export default {
    name: 'emailSent',
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scoped>
.main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
}
.letter {
    border: solid 2px grey;
    height: 150px;
    width: 300px;
    background-color: #f5f4e9;
    text-align: center;
    align-content: center;
}
.mail {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 5s linear infinite;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>